export default __webpack_public_path__ + "static/media/banner-2.4206dd77.png";